// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import 'swiper/css';
import 'swiper/css/pagination';

// 🟩 Tambahkan ini sebelum render
import './i18n';

import App from './App';
import { AuthProvider } from './context/AuthContext';
import ThemeProvider from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isDev = process.env.NODE_ENV === 'development';

const content = (
  <ThemeProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeProvider>
);

root.render(
  isDev ? content : <React.StrictMode>{content}</React.StrictMode>
);
